import { createRoute } from "@tanstack/react-router";
import { withPermission } from "../lib/with-permission";
import { rootRoute } from "./__root";
import { OfferFormPage } from "./offers.new";

function OfferEditPage() {
	const { id } = route.useParams();
	return <OfferFormPage editId={id} />;
}

export const route = createRoute({
	getParentRoute: () => rootRoute,
	path: "/offers/$id/edit",
	component: withPermission(OfferEditPage, "offers", "update"),
});
